import './components/share'

import './scss/st9/styles.scss'
